type Props = {
    title: string;
    actionLabel?: string;
};

export default function SectionTitle({ title, actionLabel }: Props) {
    return (
        <div className="mb-5 flex items-end justify-between gap-4">
            <h2 className="text-2xl font-black uppercase tracking-tight text-white md:text-4xl">
                {title}
            </h2>

            {actionLabel ? (
                <button className="text-sm font-black text-[#e5ff00] transition hover:text-[#ff7a00]">
                    {actionLabel}
                </button>
            ) : null}
        </div>
    );
}